import React from 'react';
import { CTAButton } from './CTAButton';
import { societies } from '../data/content';
export function Imagine() {
  return <section className="w-full bg-cream px-4 py-14 sm:py-20" data-id="element-141" data-mp="iybsu8cin5er">
      <div className="mx-auto w-full max-w-2xl text-center" data-id="element-142" data-mp="e625n02scjg6">
        <h2 className="font-display text-[1.65rem] font-bold leading-tight text-navy sm:text-4xl" data-id="element-143" data-mp="e47lvp392xdo">
          De la incertidumbre clínica a la <em className="italic text-gold" data-id="element-144" data-mp="55ci0jnohzdj">confianza absoluta</em>
        </h2>
        <p className="mt-4 text-[15px] leading-relaxed text-navy/70 sm:text-lg" data-id="element-145" data-mp="539hh5owgnuk">
          Deja de buscar respuestas en múltiples guías. Empieza a seguir una sola Ruta Clínica.
        </p>

        <div className="mt-8 flex flex-wrap items-center justify-center gap-2" data-id="element-146" data-mp="3rewwraqaj8b0">
          {societies.map(s => <span key={s} className="rounded-full border border-navy/15 bg-white px-3.5 py-1.5 text-xs font-bold tracking-wide text-navy/70 sm:text-sm" data-id="element-147" data-mp="1plh3e62tjfcc">
              {s}
            </span>)}
        </div>

        <div className="mt-8 space-y-4 text-left text-[15px] leading-relaxed text-navy/70 sm:text-lg" data-id="element-148" data-mp="9ziowk8kvrw3">
          <p data-id="element-149" data-mp="f1rk7n8xb61d">
            Cada año, miles de médicos invierten decenas de horas intentando interpretar
            recomendaciones de la NAMS, IMS, EMAS, ACOG y otras sociedades científicas.
          </p>
          <p className="font-semibold text-navy" data-id="element-150" data-mp="52ahneoyx89m">
            El problema no es la falta de información. El problema es que toda esa información está
            dispersa.
          </p>
          <p className="rounded-2xl border border-gold/40 bg-gold-pale px-4 py-3.5 font-display text-lg italic leading-snug text-navy sm:text-xl" data-id="element-151" data-mp="xpd3p7cgjqiz">
            Y mientras intentas encontrar la respuesta correcta… tu paciente ya está esperando una
            decisión.
          </p>
          <p data-id="element-152" data-mp="1bpecd8yys290">
            Con Ruta Clínica de Menopausia™, toda esa evidencia se convierte en un proceso lógico,
            claro y fácil de seguir.
          </p>
        </div>

        <div className="mt-7 grid grid-cols-1 gap-2 sm:grid-cols-3" data-id="element-153" data-mp="1qdo58x3snsbo">
          {['Solo abre el algoritmo.', 'Sigue la ruta.', 'Toma la mejor decisión.'].map((t, i) => <div key={t} className="flex items-center gap-2.5 rounded-xl border border-navy/10 bg-white px-4 py-3 text-left text-sm font-semibold text-navy sm:text-[13px]" data-id="element-154" data-mp="1m9q7apq7gnk7" data-mpi={i}>
              <span className="flex h-6 w-6 shrink-0 items-center justify-center rounded-full bg-gold text-[11px] font-bold text-navy-deep" data-id="element-155" data-mp="17e1tc8v34m34">
                {i + 1}
              </span>
              {t}
            </div>)}
        </div>

        <div className="mt-9" data-id="element-156" data-mp="ymrp9nmft7k6">
          <CTAButton label="Quiero decidir con una sola ruta" note="Acceso inmediato · Pago único" data-id="element-157" data-mp="yjm2wg570js5" />
        </div>
      </div>
    </section>;
}